var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.openModal
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "modal fade show",
            staticStyle: { display: "block" },
            attrs: {
              id: "go-modal-login-move",
              tabindex: "-1",
              "aria-hidden": "true",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog go-modal-plan" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.close },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-block-header" }, [
                    _c("div", { staticClass: "go-msg-title" }, [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.getMapTypeChangePlanAndMessage1[
                              _vm.typeChangePlan
                            ]
                          ),
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.typeChangePlan === _vm.TYPE_CHANGE_PLAN.UPGRADE
                    ? _c("div", { staticClass: "go-block-body" }, [
                        _c("span", {
                          staticClass: "go-text-sub",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("payment.plan.confirm.upgradeMessage2", {
                                currentPlanTitle: _vm.currentPlanTitle,
                                nextPlanTitle: _vm.nextPlanTitle,
                              })
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "bg-gray" }, [
                          _vm.getSpecificRoleUser() !== "Free"
                            ? _c("div", { staticClass: "go-msg-text" }, [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "payment.plan.confirm.upgradeMessage3"
                                        )
                                      ) +
                                      " "
                                  ),
                                  _c("b", [
                                    _vm._v("$" + _vm._s(_vm.creditAmount)),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "go-form-feedback-help" }, [
                          _vm._v(
                            "* " +
                              _vm._s(
                                _vm.$t("payment.plan.confirm.upgradeMessage4", {
                                  nextPlanTitle: _vm.nextPlanTitle,
                                })
                              )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.typeChangePlan === _vm.TYPE_CHANGE_PLAN.DOWNGRADE
                    ? _c("div", { staticClass: "go-block-body" }, [
                        _c("span", {
                          staticClass: "go-text-sub",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("payment.plan.confirm.downgradeMessage2", {
                                currentPlanTitle: _vm.currentPlanTitle,
                                nextPlanTitle: _vm.nextPlanTitle,
                              })
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "bg-gray" }, [
                          _c("div", { staticClass: "go-msg-text" }, [
                            _c("ul", [
                              _c("li", [
                                _c(
                                  "em",
                                  { staticClass: "text-left max-w-70" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "payment.plan.confirm.downgradeMessage3",
                                          {
                                            currentPlanTitle:
                                              _vm.currentPlanTitle,
                                          }
                                        )
                                      ) + " :"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.getSpecificRoleUser() === "Free"
                                  ? _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertDateToCustomFormat(
                                            _vm.moment(new Date()),
                                            "yyyy.MM.dd"
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertDateToCustomFormat(
                                            _vm.date,
                                            "yyyy.MM.dd"
                                          )
                                        )
                                      ),
                                    ]),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "em",
                                  { staticClass: "text-left max-w-70" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "payment.plan.confirm.downgradeMessage4",
                                          { nextPlanTitle: _vm.nextPlanTitle }
                                        )
                                      ) + " :"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.getSpecificRoleUser() === "Free"
                                  ? _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertDateToCustomFormat(
                                            _vm.moment(new Date()),
                                            "yyyy.MM.dd"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.convertDateToCustomFormat(
                                        _vm.typeChangePlan ===
                                          _vm.TYPE_CHANGE_PLAN.UPGRADE
                                          ? _vm.date
                                          : _vm.addDays(_vm.date, 1),
                                        "yyyy.MM.dd"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.typeChangePlan === _vm.TYPE_CHANGE_PLAN.CANCEL
                    ? _c("div", { staticClass: "go-block-body" }, [
                        _c("div", { staticClass: "go-msg-info" }, [
                          _c("dl", [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("payment.plan.confirm.cancelMessage2")
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("dl", [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("dd", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "payment.plan.confirm.cancelMessage3",
                                    {
                                      currentPlanTitle: _vm.currentPlanTitle,
                                      cancelDate: _vm.convertDateToCustomFormat(
                                        _vm.date,
                                        "yyyy.MM.dd"
                                      ),
                                    }
                                  )
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("dl", [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("dd", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("payment.plan.confirm.cancelMessage4")
                                ),
                              },
                            }),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.typeChangePlan === _vm.TYPE_CHANGE_PLAN.CANCEL
                    ? _c("div", { staticClass: "go-block-between" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: { click: _vm.close },
                          },
                          [_vm._v(_vm._s(_vm.$t("payment.button.close")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-primary",
                            attrs: {
                              type: "button",
                              disabled: _vm.waitingChangePlanApi,
                            },
                            on: { click: _vm.yes },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("payment.button.cancelPlan")) +
                                "\n              "
                            ),
                            _vm.waitingChangePlanApi
                              ? _c("b-spinner", {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { small: "", label: "Small Spinner" },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _c("div", { staticClass: "go-block-between" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: { click: _vm.close },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("payment.button.cancel")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-primary",
                            attrs: {
                              type: "button",
                              disabled: _vm.waitingChangePlanApi,
                            },
                            on: { click: _vm.yes },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("payment.button.switchPlan")) +
                                "\n              "
                            ),
                            _vm.waitingChangePlanApi
                              ? _c("b-spinner", {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { small: "", label: "Small Spinner" },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal-backdrop fade show" }),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("i", { staticClass: "go-icon-22 go-icon-check" })])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("i", { staticClass: "go-icon-22 go-icon-check" })])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [_c("i", { staticClass: "go-icon-22 go-icon-check" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }